import React, { useState, useEffect ,useRef} from "react";
import {
  Card,
  CardBody,
  Form,
  Col,
  Row,
  FormGroup,
  Alert,
  Container,
  Button,
  Label,
  Input,
  CardSubtitle
} from "reactstrap";
import MultiSelect from './MultiSelect.js';
//import './style.css';
import Breadcrumbs from "../../../components/Common/Breadcrumb.js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { useNavigate, useParams } from "react-router-dom";
import Dropzone from "react-dropzone";
import axios from "axios";
import {BACKEND_URL_DOC, BACKEND_URL_PORTAIL } from "../../../config/const.js";
import { useTranslation } from "react-i18next";
import moment from "moment-timezone";
import { countries, StateProvince, StateProvinceUS } from "./Constans.js"; // Adjust the path if necessary
import "./Styles.css";
import { BasicTable } from "../ListUsers/datatableCom.js";
import { Link } from 'react-router-dom';
import { set } from "lodash";
const UpdateGroup = () => {
  const userRoles = JSON.parse(localStorage.getItem('userRoles')) || [];
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { groupId } = useParams();

  const now = new Date();
  document.title = t("updateGroupTitle");
  const [country, setCountry] = useState("CA");
  const [province, setProvince] = useState("QC");
  const [timeZone, setTimeZone] = useState("America/Toronto");
  const [provinces, setProvinces] = useState([]);
  const [timeZones, setTimeZones] = useState([]);
  const [timeFormat, setTimeFormat] = useState("H:i"); // Default format
  const [currentTime, setCurrentTime] = useState(
    moment.tz(now, timeZone).format("HH:mm")
  );
  const [tempList, setTempList] = React.useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [numberInput, setNumberInput] = useState('numberInput');
  const [officeType, setOfficeType] = useState("pharmacy");
  const [emails, setEmails] = useState([]);
  const [emailToAdd, setEmailToAdd] = useState("");
  const [emailLanguage, setEmailLanguage] = useState(
    localStorage.getItem("lang")
  );
  const [selected, setSelected] = useState([]);
  const [tempAffectedList, setTempAffectedList] = useState([]);
  const [oldSelected, setOldSelected] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [emailError, setEmailError] = useState(null);
  const [nameError, setNameError] = useState(null);
  const [addGroupError, setAddGroupError] = useState(null);
  const [logoNameError, setLogoNameError] = useState(null);
  const [users, setUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [errorRefreshInput, SetErrorRefreshInput] = useState();
  const [addressError, setAddreessError] = useState(null);
  const [checkAdminClient, setCheckAdminClient] = useState(false);
  const [phoneError, setPhoneError] = useState(null);
  const [groupByUser, setGroupByUser] = useState([]);
  const [filesUplod, setFilesUplod] = useState([]);
  const [storage, setStorage] = useState(50);
  const [formData, setFormData] = useState({
    id:'',
    name: "",
    phone: "",
    separator: "/",
    dateformat: "Y/m/d",
    adress: "",
    country: country,
    timezone: timeZone,
    hourformat: timeFormat,
    state: province,
    officeType: officeType,
    shortName: "",
    emails: emails,
    addQuessLite: false,
    isQuessLogs: false,
    isQuessControl: false,
    isQuessCompounding: false,
    isQuessLms: false,
    isQuessDocs: false,
    isQuessPP: false,
    isSterileNotDangerous: false,
    isSterileDangerous: false,
    isNoSterile: false,
    isSterileDangNonDang: false,
    
    isUsms: false,
    refreshInSeconds: 0, 
    File: "",
  });
  const config = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  };
 
  useEffect(() => {
    window.scrollTo(0, 0);
    if (userRoles.includes('adminClient') && !userRoles.includes('admin')) {
      setCheckAdminClient(true);
    } else {
      setCheckAdminClient(false);
    }
    getClientTypeInstallation();
    getClientModule();
    getGroupdetails();
    getgrouppermission();
    getgrouplmspermission();
    getgroupdocspermission();
    getAllTemplates();
    getAffectedTemps();
  }, []);
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(
        moment.tz(now, timeZone).format(timeFormatToMomentFormat(timeFormat))
      );
    }, 60000); // Update every minute
    return () => clearInterval(interval);
  }, [timeFormat, timeZone]);
  useEffect(() => {
    setCurrentTime(
      moment.tz(now, timeZone).format(timeFormatToMomentFormat(timeFormat))
    );
  }, [timeZone]);
  const updateEmail = (id) => {
    const config = {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      },
    };
     // Transformer tous les objets pour avoir uniquement `lang`
 /*  const transformedEmails = emails.map(({ email, lang, language }) => ({
    email,
    lang: lang || language || "", 
  })); */
    const data = {
      idGroup: id,
      newEmails: emails,
    };
    axios
      .post(BACKEND_URL_PORTAIL + 'api/updateClientMail', data, config)
      .then((response) => {
      axios
      .post(BACKEND_URL_DOC+'updateClientMailLog', data)
      .then((response2) => {});
      });
  };
  const getGroupdetails = async () => {
    const data1 = {
      idGroup:groupId
    };
    const response = await axios.post(`${BACKEND_URL_PORTAIL}api/getClientDetails`, data1, config);
    const groupInfos = response[0];
    setFormData(prevFormData => ({
      ...prevFormData,      id:groupId,
      name: groupInfos.name,
      phone: groupInfos.phone,
      separator: "/",
      dateformat: "Y/m/d",
      adress: groupInfos.address,
      country: groupInfos.country,
      timezone: groupInfos.timezone,
      hourformat: groupInfos.hourFormat,
      state: groupInfos.state,
      officeType: groupInfos.officeType,
      shortName: groupInfos.shortname,
      emails: groupInfos.emails,
      logo:groupInfos.logo,
      addQuessLite:groupInfos.isQuessLite,
      refreshInSeconds: groupInfos.dashboardInterval,
      isUsms:groupInfos.isUsms,
      File: "",
    }));
     initialProvince.current = groupInfos.state;
     initialTimeZone.current = groupInfos.timezone;
      setCountry(groupInfos.country);
      setProvince(groupInfos.state);
      setTimeZone(groupInfos.timezone);
      setTimeFormat(groupInfos.hourFormat);
isInitialized.current = true;
  // Charger les listes de provinces/timezones sans reset
  if (groupInfos.country === "US") {
    setProvinces(StateProvinceUS);
    setTimeZones(getTimezonesByCountry("US"));
  } else {
    setProvinces(StateProvince);
    setTimeZones(getTimezonesByCountry("CA"));
  }

  isInitialized.current = true;
    const logos = [];
        logos.push(groupInfos.logo);
    if (groupInfos.logo != "" && groupInfos.logo != null) {
      setSelectedFiles([{
        name: groupInfos.logo,
        preview:  BACKEND_URL_PORTAIL+groupInfos.logoUrl
      }]);
    }
    setCountry(groupInfos.country);
    setProvince(groupInfos.state);
    setTimeZone(groupInfos.timezone);
    setTimeFormat(groupInfos.hourFormat);
    setOfficeType(groupInfos.officeType)
    setEmails(groupInfos.emails)
    const data={
      groupId:groupId
    }
   
    const responseUsers = await axios.post(
      `${BACKEND_URL_PORTAIL}api/getGroupUsers`, data,
      config
    );
    setUsers(responseUsers);
     const groupLimit=  await axios.get(BACKEND_URL_DOC+ 'getGroupLimits/' + groupId, config);
     console.log("groupLimit",groupLimit)
    setStorage(groupLimit.maxStorageAmount?groupLimit.maxStorageAmount:50);
  };

  const getAllTemplates = () => {
    const config = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    };
    axios.get(BACKEND_URL_DOC + "getAllTemplates/", config).then((res) => {
      setTempList(res);
    }).catch(error => console.error(error));
  };


  const myArray = Array.isArray(tempList) 
  ? tempList.map((el) => ({ label: el.name, value: el.name, id: el.idTemplate }))
  : [];


  
  console.log("groupStorage",storage)

  const getAffectedTemps = () => {
    
  const config = {
    headers: { Authorization: "Bearer " + localStorage.getItem("token") },
  };
  
  axios
    .get(BACKEND_URL_DOC + "getAffectedTemps/" + groupId, config)
    .then((res) => {

      const selectedArray = res.map((el) => ({
        label: el.name,
        value: el.name,
        id: el.idTemplate,
      }));

      setSelected(selectedArray);
      setOldSelected(selectedArray);
    })
    .catch((error) => console.error("Error fetching data:", error));
};

  const getgroupdocspermission = () => {
    const config = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    };
    axios
      .get(BACKEND_URL_DOC + "getgroupdocspermissionByGroup/" + groupId, config)
      .then((response) => {
        
        setFormData((prevFormData) => ({
          ...prevFormData,
          isQuessDocs: response[0].Statut,
        }));
        
        
      });
  };

  const getgrouplmspermission = () => {
    const config = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    };
    axios
      .get(BACKEND_URL_PORTAIL + "api/getgrouplmspermission/" + groupId, config)
      .then((response) => {
        
        setFormData((prevFormData) => ({
          ...prevFormData,
          isQuessLms: response[0].Statut,
        }));
        
        
      });
  };


    const updateClientStorage = (id) => {
    const config = {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      },
    };
    const data = {
      idGroup: id,
      storage: storage,
    };
     axios
      .post(BACKEND_URL_DOC+'setGroupLimits', {idGroup: id,storage: storage,},config)
      .then((response2) => {});
     
      
  };
  const handleChangeStorage = (event) => {
    const inputValue = event.target.value;
    setStorage(inputValue);
  };
  const getgrouppermission = () => {
    const config = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    };
    axios
      .get(BACKEND_URL_DOC + "getGroupPermissionByGroup/" + groupId, config)
      .then((response) => {
        
        
        setFormData((prevData) => ({
          ...prevData,
          isQuessPP: response[0].Statut=="1"?true:false,
        }));
        setGroupByUser(response);
        setLoading(false)
      });
  };
  const saveOrUpdateQuessDocsPermission = (idGroup, status) => {
    const config = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    };
    const data = {
      idGroup,
      permission: status,
    };
    axios.post(BACKEND_URL_DOC + "saveOrUpdateQuessDocsPermission", data, config)
      .then((response) => {
      }).catch(error => console.error(error));
  };
  const affectGroupToTemplates = () => {
    const config = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    };
    const listTemps = [];
    selected.forEach((el) => {
      listTemps.push(el.id);
    });
    const data = {
      idGroup: groupId,
      temps: listTemps,
    };
    if (listTemps) {
      axios
        .post(BACKEND_URL_DOC + "affectTemplatesToGroup", data, config)
        .then((response) => {});
    }
  };
  const getClientTypeInstallation = () => {
    const config = {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      },
    };
    const data = { idGroup:groupId };
  
    axios
      .post(BACKEND_URL_PORTAIL + 'api/getClientTypeInstallation', data, config)
      .then((response) => {
        const clientTypes = response;
  
        setFormData((prevFormData) => ({
          ...prevFormData,
          isSterileNotDangerous: clientTypes.includes('Stérile | Non Dangereux'),
          isSterileDangerous: clientTypes.includes('Stérile | Dangereux'),
          isNoSterile: clientTypes.includes('Non-Stérile'),
          isSterileDangNonDang: clientTypes.includes('Stérile | Non dangereux et dangereux avec SAS partagé'),
        }));
      })
      .catch((error) => {
        console.error("Erreur lors de la récupération des types d'installation", error);
      });
  };
  const getClientModule = () => {
    const config = {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      },
    };
    const data = { idGroup:groupId };
  
    axios
      .post(BACKEND_URL_PORTAIL + 'api/getClientModule', data, config)
      .then((response) => {
        const clientModules = response;
  
        setFormData((prevFormData) => ({
          ...prevFormData,
          isQuessLogs: clientModules.includes('quessLogs'),
          isQuessControl: clientModules.includes('quessControl'),
          isQuessCompounding: clientModules.includes('quessCompounding'),
        }));
      })
      .catch((error) => {
        console.error("Erreur lors de la récupération des modules client", error);
      });
  };
  
  const handleChangeRefreshInSeconds = (event) => {
    const inputValue = event.target.value;
    setFormData({
      ...formData,
      refreshInSeconds: event.target.value,
    })
  
   if (inputValue === "") {
    setNumberInput('numberInputError');
    SetErrorRefreshInput(t('ErrorRefreshInput'));
   }
    else if (
      inputValue == 0 | (inputValue >= 30
        && inputValue <= 180)
    ) {
      setNumberInput('numberInput');
      SetErrorRefreshInput('');
    } else {
      setNumberInput('numberInputError');
      SetErrorRefreshInput(t('ErrorRefreshInput'));
    }
  };

  const handleChange = (e) => {
    const { name, checked } = e.target; // `name` est le nom du champ, `checked` est la valeur de la case à cocher
    setFormData((prevData) => ({
      ...prevData,
      [name]: !checked,
    }));
  };
  // Function to handle time format change
  const handleChangeTimeFormat = (e) => {
    const selectedFormat = e.target.value;
    const now = new Date();
    setTimeFormat(selectedFormat); // Update the selected format
    setCurrentTime(
      moment.tz(now, timeZone).format(timeFormatToMomentFormat(selectedFormat))
    ); // Reformat time immediately
  };

  // Helper function to map select value to moment.js format
  const timeFormatToMomentFormat = (timeFormat) => {
    switch (timeFormat) {
      case "H:i":
        return "HH:mm"; // 24-hour format without seconds
      case "h:i A":
        return "h:mm A"; // 12-hour format with AM/PM
      case "H\\hi":
        return "HH[h]mm"; // Custom format with "h" as literal
      case "h\\hi A":
        return "h[h]mm A"; // Custom format with AM/PM
      default:
        return "HH:mm";
    }
  };
  const getTimezonesByCountry = (countryCode) => {
    // Get all timezones for the given country code
    const timezones = moment.tz.zonesForCountry(countryCode);
    const now = new Date();

    // Map over each timezone to get the current time
    return timezones.map((timezone) => {
      return {
        timezone,
        currentTime: moment
          .tz(now, timezone)
          .format(timeFormatToMomentFormat(timeFormat)), // Format the current time
      };
    });
  };
  const checkAddress=()=> {
    if(formData.name=="")
      {
        setAddreessError(true)
       return false
      } 
      else {
        setAddreessError(null)
        return true
      }
  }
  const checkPhone=()=> {
   
    if(formData.shortName=="")
      {
        setPhoneError(true)
       return false
      }  
      else {
        setPhoneError(null)
        return true
      }
  }
  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Basic regex for email validation
    return re.test(email);
  };
  const isInitialized = useRef(false);
  const initialProvince = useRef(null);
  const initialTimeZone = useRef(null);
useEffect(() => {
  if (!isInitialized.current) return;

  if (country === "US") {
    setProvinces(StateProvinceUS);
    setTimeZones(getTimezonesByCountry("US"));
    setTimeZone(initialTimeZone.current || "America/New_York"); // ← valeur BD
    setProvince(initialProvince.current || "NY");
  } else {
    setProvinces(StateProvince);
    setTimeZones(getTimezonesByCountry("CA"));
    setTimeZone(initialTimeZone.current || "America/Toronto"); // ← valeur BD
    setProvince(initialProvince.current || "QC");
  }

  // Reset après premier usage pour que les prochains changements manuels fonctionnent normalement
  initialProvince.current = null;
  initialTimeZone.current = null; // ← reset
}, [country]);

  const checkGroupName = () => {
    if (formData.name == "") {
      setNameError(true);
      return false;
    } else {
      setNameError(null);
      return true;
    }
  };
  const checkLogoName = () => {
    if (formData.shortName == "") {
      setLogoNameError(true);
      return false;
    } else {
      setLogoNameError(null);
      return true;
    }
  };
  const saveOrUpdatePermissionPP = (idGroup, status) => {
    const config = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    };
    const data = {
      idGroup,
      status,
    };
    axios
      .post(BACKEND_URL_DOC + "saveOrUpdatePermissionPP", data, config)
      .then((response) => {
        const updatedList = groupByUser.map((item) => {
          if (item.Id == idGroup) {
            return { ...item, Statut: status };
          }
          return item;
        });
        setGroupByUser(updatedList);
        
        setTimeout(() => {
          window.location.reload();
        }, 3000);
      });
  };
  

  const handleSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();
    if (formData.refreshInSeconds === "") {
      setNumberInput('numberInputError');
      SetErrorRefreshInput(t('ErrorRefreshInput'));
     }
      else if (
        formData.refreshInSeconds == 0 | (formData.refreshInSeconds >= 30
          && formData.refreshInSeconds <= 180)
      ) {
        setNumberInput('numberInput');
        SetErrorRefreshInput('');
      } else {
        setNumberInput('numberInputError');
        SetErrorRefreshInput(t('ErrorRefreshInput'));
      }
    const groupNameValid= checkGroupName()
    const logoNameValid= checkLogoName()
    const isValidPhone= checkPhone();
    const isValidAddress = checkAddress();
    if(((formData.refreshInSeconds == 0) || (formData.refreshInSeconds >= 30 && formData.refreshInSeconds <= 180)) 
      && (formData.isQuessLogs || formData.isQuessControl)
      &&!(formData.isSterileDangNonDang || formData.isSterileDangerous || formData.isSterileNotDangerous || formData.isNoSterile)
      || (!groupNameValid || !logoNameValid || !isValidPhone || !isValidAddress ))
    {
      setAddGroupError({ text: t("failureUpdateGroup"), type: "error" });
      setTimeout(() => {
        setAddGroupError(null);
        setLoading(null);
      }, 2500);
    } else {
      const configUpload = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "multipart/form-data",
        },
      };
      const groupData = new FormData();
      groupData.append('dashboardInterval', formData.refreshInSeconds);
      groupData.append("idGroup", formData.id);
      groupData.append("name", formData.name);
      groupData.append("phone", formData.phone);
      groupData.append("address", formData.adress);
      groupData.append("timezone", timeZone);
      groupData.append("hourformat", timeFormat);
      groupData.append("dateformat", "Y/m/d");
      groupData.append("country", country);
      groupData.append("state", province);
      groupData.append("officeType", officeType);
      groupData.append("shortName", formData.shortName);
      groupData.append("separator", formData.separator);
      groupData.append("emails", JSON.stringify(emails)); // Stringify the array of objects
      groupData.append('isSterileNoDangereux', formData.isSterileNotDangerous);
      groupData.append('isSterileDangereux', formData.isSterileDangerous);
      groupData.append('isNoSterile', formData.isNoSterile);
      groupData.append('isSterileDangNoDang', formData.isSterileDangNonDang);
      groupData.append('isQuessLogs', formData.isQuessLogs);
      groupData.append('isQuessControl', formData.isQuessControl);
      groupData.append('isQuessLms', formData.isQuessLms);
      groupData.append('isQuessCompounding', formData.isQuessCompounding);
      groupData.append('isQuessDocs', formData.isQuessDocs);
      groupData.append('isQuessPP', formData.isQuessPP);
      groupData.append('isQuessLite', formData.addQuessLite)
      groupData.append('isUsms', formData.isQuessControl ? formData.isUsms : false);

      if (filesUplod.length != 0) {
        groupData.append('File', filesUplod[0]);
        if (filesUplod[0].path.substring(0, 1) != '') {
          if (filesUplod[0].path.substring(0, 1) === '/') {
            groupData.append(
              'path',
              filesUplod[0].path.substring(1, filesUplod[0].path.length)
            );
          } else {
            groupData.append('path', filesUplod[0].path);
          }
        } 
      } else {
          
          const fileName = selectedFiles?.[0]?.name || "";
          groupData.append('path', fileName);
        }

      const response = await axios.post(
        `${BACKEND_URL_PORTAIL}api/updateClientAll`,
        groupData,
        configUpload
      );
      if (response.id) {
        updateEmail(response.id);
        
        updateClientStorage(response.id);
        affectGroupToTemplates();
          
          if (formData.isQuessDocs) {
            saveOrUpdateQuessDocsPermission(groupByUser[0].Id, 1);
          } else {
            saveOrUpdateQuessDocsPermission(groupByUser[0].Id, 0);
          }
          if (formData.isQuessPP) {
            saveOrUpdatePermissionPP(groupByUser[0].Id, 1);
            axios
              .post(
                BACKEND_URL_DOC + "affectDeuxFA_AdminGroup",
                { groupeId: groupId },
                config
              )
              .then((resp) => {});
          } else {
            saveOrUpdatePermissionPP(groupByUser[0].Id, 0);
          }
        setAddGroupError({ text: t("successUpdateGroup"), type: "success" });
        setTimeout(() => {
          setAddGroupError(null);
          setLoading(null);
          navigate("/groups-management");
        }, 2500);
      } else {
        setAddGroupError({ text: t("failureUpdateGroup"), type: "error" });
        setTimeout(() => {
          setAddGroupError(null);
          setLoading(null);
        }, 2500);
      }
    }
  };

  const goBack = () => {
    navigate("/groups-management");
  };
  
  const handleEmailAdd = () => {
    if (!validateEmail(emailToAdd)) {
      setEmailError(true);
      return;
    } else {
      setEmailError(false);
      const emailToAddData = {
        email: emailToAdd,
        lang: emailLanguage,
      };
      setEmails([...emails, emailToAddData]);
      setEmailToAdd("");
      setEmailLanguage(localStorage.getItem("lang"));
    }
  };
  const handleDeleteEmail = (email) => {
    const updatedEmails = emails.filter((em) => em != email);
    setEmails(updatedEmails);
  };

  function handleAcceptedFiles(files) {
    files.map((file) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      })
    );
    setSelectedFiles(files);
    setFilesUplod(files);
  }
  const handleRemoveFile = () => {
    // Remove the selected file from the state
    setSelectedFiles([]);
  };
  
  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }
 
  const handlePhoneInput = (value) => {
    // Remove all non-digit characters
    const cleaned = value.replace(/\D/g, "").slice(0, 10); // Limit to 10 digits
  
    // Format the input as (XXX) XXX-XXXX
    const formatted = cleaned
      .replace(/^(\d{3})(\d{0,3})(\d{0,4})$/, (_, p1, p2, p3) => {
        let result = `(${p1}`;
        if (p2) result += `) ${p2}`;
        if (p3) result += `-${p3}`;
        return result;
      });
  
    // Update formData with the formatted phone number
    setFormData({ ...formData, phone: formatted });
  };
  return (
    <React.Fragment>
      <div className="page-content">
        <Container  style={{marginTop:"1%"}} fluid={true}>
          <Card className="card-bordred custom-card">
 <Breadcrumbs
            title={t("groupsManagement")}
            breadcrumbItem={t("updateGroup")}
          />
          {loading ? (
            <Alert color="info">{t("loadingSubmission")}</Alert>
          ) : error ? (
            <Alert color="danger">{error}</Alert>
          ) : null}
          <div className=" mb-4">
            <div
              style={{
                margin: "1%",
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
            </div>

            <Form onSubmit={handleSubmit}>
              <Row>
                <Col lg={12}>
                  <Card className="card-bordred">
                  <div className="card-header custom-header">
                  <button
                    className="btn btn-primary"
                    title={t("goBack")}
                    onClick={() => goBack()}
                  >
                    <i className="fas fa-arrow-left"></i>
                  </button>
                  </div>
                    <CardBody>
                      <Card className="card-bordred">
                        <CardBody className="paperGroupStyle">
                          <Row className="mt-1">
                            <Col>
                            <label className="form-label">
                                {t("groupName")}
                              </label>
                            </Col>
                            <Col lg={10}>
                              <input
                                name="groupName"
                                className="form-control"
                                type="text"
                                placeholder={t("name")}
                                value={formData.name}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    name: e.target.value,
                                  })
                                }
                                disabled={checkAdminClient}
                              />
                              {nameError && (
                                <code className="text-danger">
                                  {" "}
                                  {t("groupNameRequired")}
                                </code>
                              )}
                            </Col>
                          </Row>
                          <Row className="mt-1">
                            <Col lg={2}>
                              <label className="form-label">{t("phone")}</label>
                            </Col>
                            <Col lg={10}>
                              <input
                                name="phone"
                                className="form-control"
                                type="text" // Use text instead of number for formatting
                                placeholder={t("phone")} // e.g., "Enter phone number"
                                value={formData.phone}
                                onChange={(e) => handlePhoneInput(e.target.value)}
                              />
                               {phoneError && (
                                <code className="text-danger">
                                  {" "}
                                  {t("phoneRequired")}
                                </code>
                              )}
                            </Col>
                          </Row>
                          <Row className="mt-1">
                            <Col lg={2}>
                            <label className="form-label">
                                {t("address")}
                              </label>
                            </Col>
                            <Col lg={10}>
                              <input
                                name="address"
                                className="form-control"
                                type="text"
                                placeholder={t("address")}
                                value={formData.adress}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    adress: e.target.value,
                                  })
                                }
                              />
                               {addressError && (
                                <code className="text-danger">
                                  {" "}
                                  {t("addressRequired")}
                                </code>
                              )}
                            </Col>
                          </Row>
                        </CardBody>
                      </Card>
                      <Card className="card-bordred">
                        <CardBody className="paperGroupStyle">
                          <Row className="mt-1">
                            <Col lg={4}>
                              <label className="form-label">
                                {t("country")}
                              </label>
                              <select className="form-select" value={country} onChange={(e) => setCountry(e.target.value)}>

                                <option
                                  aria-selected="true"
                                  role="option"
                                  value="0"
                                  disabled
                                >
                                  {t("selectCountry")}
                                </option>
                                {countries.map((country) => (
                                  <option
                                    key={country.value}
                                    value={country.value}
                                  >
                                    {t(country.label)}
                                  </option>
                                ))}
                              </select>
                            </Col>
                            <Col lg={4}>
                              <label className="form-label">
                                {t("stateProvince")}
                              </label>
                              <select
                                className="form-select"
                                value={province}
                                onChange={(e) => setProvince(e.target.value)}
                              >
                                <option
                                  aria-selected="true"
                                  role="option"
                                  value="0"
                                  disabled
                                >
                                  {t("selectProvince")}
                                </option>
                                {provinces.map((prov) => (
                                  <option key={prov.value} value={prov.value}>
                                    {prov.label}
                                  </option>
                                ))}
                              </select>
                            </Col>
                            <Col lg={4}>
                              <label className="form-label">
                                {t("timeZone")}
                              </label>
                              <select
                                className="form-select"
                                value={timeZone}
                                onChange={(e) => setTimeZone(e.target.value)}
                              >
                                <option
                                  aria-selected="true"
                                  role="option"
                                  value="0"
                                  disabled
                                >
                                  {t("selecttimeZone")}
                                </option>
                                {timeZones.map((timeZone) => (
                                  <option
                                    key={timeZone.timezone}
                                    value={timeZone.timezone}
                                  >
                                    {timeZone.timezone +
                                      " : " +
                                      timeZone.currentTime}
                                  </option>
                                ))}
                              </select>
                            </Col>
                          </Row>
                          <Row className="mt-1">
                            <Col lg={4}>
                              <label className="form-label">
                                {t("dateFormat")}
                              </label>
                              <select
                                className="form-select"
                                value={"yyyy/mm/dd"}
                                disabled
                              >
                                <option
                                  aria-selected="true"
                                  role="option"
                                  value="yyyy/mm/dd"
                                  disabled
                                >
                                  yyyy/mm/dd
                                </option>
                              </select>
                            </Col>
                            <Col lg={4}>
                              <label className="form-label">
                                {t("separateur")}
                              </label>
                              <select
                                className="form-select"
                                value={"/"}
                                disabled
                              >
                                <option
                                  aria-selected="true"
                                  role="option"
                                  value="/"
                                  disabled
                                >
                                  /
                                </option>
                              </select>
                            </Col>
                            <Col lg={4}>
                              <label className="form-label">
                                {t("timeFormat")}
                              </label>
                              <select
                                className="form-select"
                                value={timeFormat}
                                onChange={handleChangeTimeFormat}
                              >
                                <option
                                  aria-selected="true"
                                  role="option"
                                  value="0"
                                  disabled
                                >
                                  {t("selecttimeZone")}
                                </option>
                                <option value="H:i">
                                  {moment.tz(now, timeZone).format(timeFormatToMomentFormat("H:i"))} (24h){" "}
                                </option>
                                <option value="h:i A">
                                  {moment.tz(now, timeZone).format(timeFormatToMomentFormat("h:i A"))} (12h){" "}
                                </option>
                                <option value="H\hi">
                                  {moment.tz(now, timeZone).format(timeFormatToMomentFormat("H\\hi"))} (24h){" "}
                                </option>
                                <option value="h\hi A">
                                  {moment.tz(now, timeZone).format(timeFormatToMomentFormat("h\\hi A"))} (12h)
                                </option>
                              </select>
                            </Col>
                          </Row>
                        </CardBody>
                      </Card>

                      <Row className="mt-1 ">
                        <Col lg={emails.length > 0 ? 7 : 12}>
                          <Card className="card-bordred">
                            <CardBody className="paperGroupStyleContact1">
                              <Row className="mt-1">
                                <Col lg={12}>
                                  <label className="form-label">
                                    {t("contact")}
                                  </label>
                                  <button
                                    className="btn btn-primary"
                                    style={{ marginLeft: "10%" }}
                                    type="button"

                                    onClick={() => handleEmailAdd()}
                                  >
                                    + {t("add")}
                                  </button>
                                </Col>
                              </Row>
                              <Row className="mt-1">
                                <Col lg={6}>
                                  <label className="form-label">
                                    {t("email")}
                                  </label>
                                  <input
                                    name="email"
                                    className="form-control"
                                    type="email"
                                    placeholder={t("email")}
                                    value={emailToAdd}
                                    onChange={(e) =>
                                      setEmailToAdd(e.target.value)
                                    }
                                  />
                                  {emailError && (
                                    <code className="text-danger">
                                      {" "}
                                      {t("errorEmail")}
                                    </code>
                                  )}
                                </Col>
                                <Col lg={6}>
                                  <label className="form-label">
                                    {t("language")}
                                  </label>
                                  <select
                                    className="form-select"
                                    value={emailLanguage}
                                    onChange={(e) =>
                                      setEmailLanguage(e.target.value)
                                    }
                                  >
                                    <option
                                      aria-selected="true"
                                      role="option"
                                      value="0"
                                      disabled
                                    >
                                      {t("selectLanguage")}
                                    </option>
                                    <option value="fr">{t("fr")}</option>
                                    <option value="en">{t("en")}</option>
                                  </select>
                                </Col>
                              </Row>
                            </CardBody>
                          </Card>
                        </Col>
                        {emails.length > 0 && (
                          <Col lg={5}>
                            <Card className="card-bordred " style={{height:"86%"}}>
                              <CardBody className="paperGroupStyleContact" >
                                {emails.map((email) => (
                                  <Row>
                                    <Col lg={9} xs={9}>
                                      <span className="email1"> {email.email}</span>
                                    </Col>
                                    <Col lg={2} xs={2}>
                                      <span className="lang">{email.lang === 'fr' ? 'fr' : 'en'}</span>
                                    </Col>
                                    <Col lg={1} xs={1}>
                                      <i
                                        className="fas fa-times-circle delete-button"
                                        onClick={() => handleDeleteEmail(email)}
                                      ></i>
                                    </Col>
                                  </Row>
                                ))}
                              </CardBody>
                            </Card>
                          </Col>
                        )}
                      </Row>
                      <Row className="mt-1 ">
                        <Col lg={12}>
                          <Card className="card-bordred">
                            <CardBody className="paperGroupStyle">
                              <Row className="mt-1 ">
                                <Col lg={6}>
                                  <Row className="mt-1 ">
                                    <Col lg={12}>
                                      <label className="form-label">
                                        {t("officeType")}
                                      </label>
                                      <select
                                        className="form-select"
                                        value={officeType}
                                        onChange={(e) =>
                                          setOfficeType(e.target.value)
                                        }
                                      >
                                        <option
                                          aria-selected="true"
                                          role="option"
                                          value="0"
                                          disabled
                                        >
                                          {t("selectOfficeType")}
                                        </option>
                                        <option value="pharmacy">
                                          {t("pharmacy")}
                                        </option>
                                        <option value="hospital">
                                          {t("hospital")}
                                        </option>
                                        <option value="clsc">
                                          {t("CLSC")}
                                        </option>
                                        <option value="other">
                                          {t("other")}
                                        </option>
                                      </select>
                                    </Col>
                                  </Row>
                                  <Row className="mt-1 ">
                                    <Col lg={12}>
                                      <label className="form-label">
                                        {t("logoName")}
                                      </label>
                                      <input
                                        name="logoName"
                                        className="form-control"
                                        type="text"
                                        placeholder={t("logoName")}
                                        value={formData.shortName}
                                        onChange={(e) =>
                                          setFormData({
                                            ...formData,
                                            shortName: e.target.value,
                                          })
                                        }
                                        disabled={checkAdminClient}
                                      />
                                      {logoNameError && (
                                        <code className="text-danger">
                                          {" "}
                                          {t("logoNameRequired")}
                                        </code>
                                      )}
                                    </Col>
                                  </Row>
                                </Col>
                                <Col lg={6}>
                                  <Card>
                                    <CardBody>
                                      <label className="form-label">
                                        {t("Logo")}
                                      </label>
                                      <Form className="dropzone">
                                        <Dropzone
                                          onDrop={(acceptedFiles) =>
                                            handleAcceptedFiles(acceptedFiles)
                                          }
                                          accept={{
                                            "image/*": [],
                                          }}
                                          maxFiles={1}
                                        >
                                          {({
                                            getRootProps,
                                            getInputProps,
                                          }) => (
                                            <div className="dropzone">
                                              <div
                                                style={{ textAlign: "center" }}
                                              >
                                                <div
                                                  className="dz-message needsclick"
                                                  {...getRootProps()}
                                                >
                                                  <input {...getInputProps()} />
                                                  <div className="mb-3 ">
                                                    <i className="display-4 text-muted ri-upload-cloud-2-line"></i>
                                                  </div>
                                                  <h4> {t("uloadFiles")}</h4>
                                                </div>
                                              </div>
                                            </div>
                                          )}
                                        </Dropzone>
                                      </Form>
                                    </CardBody>
                                  </Card>
                                </Col>
                              </Row>
                              <Row>
                              {selectedFiles.length > 0 && (
                                <div className="mt-1 text-center">
                                  {selectedFiles.map((file, index) => (
                                    <div key={index} className="mb-3">
                                      <img
                                        src={file.preview}
                                        alt={file.name}
                                        style={{
                                          maxWidth: "100%",
                                          height: "auto",
                                        }}
                                      />
                                      <ul className="list-group mt-1">
                                        <li className="list-group-item d-flex justify-content-between align-items-center">
                                          {file.name}
                                          <button
                                            type="button"
                                            className="btn btn-danger btn-sm"
                                            onClick={() => handleRemoveFile(index)}
                                            disabled={checkAdminClient}
                                          >
                                            {t("delete")}
                                          </button>
                                        </li>
                                      </ul>
                                    </div>
                                  ))}
                                </div>
                              )}
                              </Row>
                            </CardBody>
                          </Card>
                        </Col>
                      </Row>
                      {!checkAdminClient && (<>
                          <Row className="mt-1">
                          <Col lg={12}>
                            <Card className="card-bordred paperGroupStyle">
                              
                                                      {/* Titre principal */}
                                                      <CardSubtitle className="titleCard">
                                                        <h5 className="form-header-qcom " >{t("Permission")}</h5>
                                                      </CardSubtitle>
                                                      <CardBody>
                                                      <div >
                                                        {/* Checkbox "Add Quess Lite" */}
                                                        <Row className="mt-1">
                                                          <Col md={6} className="d-flex flex-column">
                                                            <div>
                                                              <div className="d-flex flex-column gap-3">
                                                                <div>
                                                                <input
                                                                      type="checkbox"
                                                                      className="form-check-input checkPermission"
                                                                      name="addQuessLite"
                                                                      checked={formData.addQuessLite}
                                                                      onClick={handleChange}
                                                                      disabled={checkAdminClient}
                                                                    />
                                                                  <label className="form-label">
                                                                  
                                                                  {t("addQuessLite")}
                                                                </label>
                                                                </div>
                                                                
                                                              </div>
                                                            </div>
                                                          </Col>
                                                        </Row>
                                                        
                                                        <Row className="mt-1">
                                                          {/* Section "Solution" */}
                                                          <Col md={6} className="d-flex flex-column">
                                                            <label className="form-label">{t("Solution")}</label>
                                                            <div className="d-flex flex-column gap-3">
                                                              <div>
                                                              <input
                                                                  type="checkbox"
                                                                  className="form-check-input checkPermission"
                                                                  name="isQuessLogs"
                                                                  checked={formData.isQuessLogs}
                                                                  onClick={handleChange}
                                                                  disabled={checkAdminClient}
                                                                />
                                                                <label className="form-label">
                                                                  
                                                                  {t("QUESSREGISTRES")}
                                                                </label>
                                                              </div>
                                                              <div>
                                                              <input
                                                                  type="checkbox"
                                                                  className="form-check-input checkPermission"
                                                                  name="isQuessControl"
                                                                  checked={formData.isQuessControl}
                                                                  onClick={handleChange}
                                                                  disabled={checkAdminClient}
                                                                />
                                                              <label className="form-label">
                                                                
                                                                {t("QUESSCONTRÔLE")}
                                                              </label>
                                                              </div>
                                                              {formData.isQuessControl && (
                                                                <div>
                                                                  <input
                                                                      type="checkbox"
                                                                      className="form-check-input checkPermission"
                                                                      name="isUsms"
                                                                      checked={formData.isUsms}
                                                                      onClick={handleChange}
                                                                    />
                                                                  <label className="form-label">
                                                                    
                                                                    {t("UsMicroSolutionsCollaboration")}
                                                                    
                                                                  </label>
                                                              </div>                       
                                                              )}
                                                                                <div>
                                                              <input
                                                                  type="checkbox"
                                                                  className="form-check-input checkPermission"
                                                                  name="isQuessCompounding"
                                                                  checked={formData.isQuessCompounding}
                                                                  onClick={handleChange}
                                                                  disabled={checkAdminClient}
                                                                />
                                                              <label className="form-label">
                                                                {t("QUESSCOMPOUNDING")}
                                                              </label>
                                                              </div>
                                                              <div>
                                                              <input
                                                                  type="checkbox"
                                                                  className="form-check-input checkPermission"
                                                                  name="isQuessLms"
                                                                  checked={formData.isQuessLms}
                                                                  onClick={handleChange}
                                                                  disabled={checkAdminClient}
                                                                />
                                                                <label className="form-label">
                                                                  
                                                                  {t("QUESS-LMS")}
                                                                </label>
                                                              </div>
                                                              
                                                              <div >
                                                                <input
                                                                  type="checkbox"
                                                                  className="form-check-input checkPermission"
                                                                  name="isQuessDocs"
                                                                  checked={formData.isQuessDocs}
                                                                  onClick={handleChange}
                                                                  disabled={checkAdminClient}
                                                                />
                                                                <label className="form-label">{t("QuessDocsPermission")}</label>
                                                              </div>
                                                              <div>
                                                                <input
                                                                  type="checkbox"
                                                                  className="form-check-input checkPermission"
                                                                  name="isQuessPP"
                                                                  onClick={handleChange}
                                                                  checked={formData.isQuessPP}
                                                                  disabled={checkAdminClient}
                                                                />
                                                                <label className="form-label">{t("QuessPPPermission")}</label>
                                                              </div>
                                                              <div>{formData.isQuessPP && (
                                                                <>
                                                             <MultiSelect  options={myArray}   disabled={checkAdminClient} selected={selected} setSelected={setSelected} 
                                                             IconComponent={(props) => (
                                                               <i className="bi bi-caret-down-fill" {...props} style={{ color: 'black' }} /> 
                                                              )}/>
                                                             </>
                                                              )}
                                                              </div>
                                                            </div>
                                                          </Col>
                      
                                                          {/* Section "Installation Type" */}
                                                          <Col md={6} className="d-flex flex-column">
                                                            <label  className="form-label">{t("InstallationType")}</label>
                                                            <div className="d-flex flex-column gap-3">
                                                            <div>
                                                            <input
                                                                  type="checkbox"
                                                                  className="form-check-input checkPermission"
                                                                  name="isSterileNotDangerous"
                                                                  checked={formData.isSterileNotDangerous}
                                                                  onClick={handleChange}
                                                                  disabled={checkAdminClient}
                                                                />
                                                              <label className="form-label">
                                                                
                                                                {t("SterileNotDangerous")}
                                                              </label>
                                                              </div>
                                                              <div>
                                                              <input
                                                                  type="checkbox"
                                                                  className="form-check-input checkPermission"
                                                                  name="isSterileDangerous"
                                                                  checked={formData.isSterileDangerous}
                                                                  onClick={handleChange}
                                                                  disabled={checkAdminClient}
                                                                />
                                                              <label className="form-label">
                                                               
                                                                {t("SterileDangerous")}
                                                              </label>
                                                              </div>
                                                              <div>
                                                              <input
                                                                  type="checkbox"
                                                                  className="form-check-input checkPermission"
                                                                  name="isNoSterile"
                                                                  checked={formData.isNoSterile}
                                                                  onClick={handleChange}
                                                                  disabled={checkAdminClient}
                                                                />
                                                              <label className="form-label">
                                                                
                                                                {t("NotSterile")}
                                                              </label>
                                                              </div>
                                                              <div>
                                                              <input
                                                                  type="checkbox"
                                                                  className="form-check-input checkPermission"
                                                                  name="isSterileDangNonDang"
                                                                  checked={formData.isSterileDangNonDang}
                                                                  onClick={handleChange}
                                                                  disabled={checkAdminClient}
                                                                />
                                                              <label className="form-label">
                                                                
                                                                {t("SterileNonDangerousAndDangerousWithSharedSAS")}
                                                              </label>
                                                              </div>
                                                              
                                                            </div>
                                                            {(!formData.isSterileDangNonDang && !formData.isSterileDangerous && !formData.isSterileNotDangerous && !formData.isNoSterile) &&(formData.isQuessLogs || formData.isQuessControl)&& (
                                                              <label className="text-danger">{t("errorTypeInstallation")}</label>
                                                            )}
                                                          </Col>
                                                        </Row>
                      
                                                      </div>
                              </CardBody>

                            </Card>
                          </Col>
                      </Row>
                    
                                   {/* Bloc "Storage" */}
                                          {
                                            Boolean(formData.isQuessDocs)  && (     <Row className="mt-1">
                                              <Col lg={12}>
                                                <Card className="card-bordred paperGroupStyle">
                                                  <CardSubtitle className="titleCard">
                                                    <h5 className="form-header-qcom" >{t("storage")}</h5>
                                                  </CardSubtitle>
                                                  <CardBody >
                                                  <Row className="mt-1">
                                                    <Col md={2} xs={4}>
                                                      <select
                                                        className="form-select"
                                                        value={storage}
                                                        onChange={(e) => handleChangeStorage(e)}
                                                      >
                                                        <option
                                                          aria-selected="true"
                                                          role="option"
                                                          value="0"
                                                          disabled
                                                        >
                                                          {t("selectStorageLimit")}
                                                        </option>
                                                        <option value="50">{t('tier')} 1 : 50 GB</option>
                                                        <option value="100">{t('tier')} 2 : 100 GB</option>
                                                        <option value="150">{t('tier')} 3 : 150 GB</option>
                                                        <option value="200">{t('tier')} 4 : 200 GB</option>
                                                        </select>
                                                        </Col>
                                                     </Row>
                                                     </CardBody>
                                                     </Card>
                                                     </Col>
                                                     </Row>)
                                          }
                      </>
                  )}
                                            
                      
                       {/* Bloc "Refresh" */}
                      {!checkAdminClient && (<Row className="mt-1">
                                              <Col lg={12}>
                                                <Card className="card-bordred paperGroupStyle">
                                                      <CardSubtitle className="titleCard">
                                                        <h5 className="form-header-qcom">{t("DashboardRefreshInSeconds")}</h5>
                                                      </CardSubtitle>
                                                  <CardBody>
                                                  
                                                    <Row className="mt-1">
                                                      <Col md={2} xs={4}>
                                                        <input
                                                          type="number"
                                                          className={"form-control "+numberInput}
                                                          name="refreshInSeconds"
                                                          value={formData.refreshInSeconds}
                                                          min="0"
                                                          max="180"
                                                          step="1"
                                                          onChange={(e) => handleChangeRefreshInSeconds(e)}
                                                        />
                                                      </Col>
                                                      <Col md={8} xs={8}>
                                                        <label className="form-label">
                                                          {t("JamaisRafraichitAutomatiquement")}
                                                        </label>
                                                        <div>
                                                        <label className="textError">
                                                          {errorRefreshInput}
                                                        </label>
                                                        </div>
                                                       
                                                      </Col>
                                                    </Row> 
                                                  </CardBody>
                                                </Card>
                                              </Col>
                      </Row>
                      )}
                      <Row className="mt-1 ">
                        <Col lg={12}>
                          <Card className="card-bordred">
                            <CardBody>
                              <Row>
                              
                                <Col sm="12">
                                <label className="form-label">
                                        {t("listOfUsers")}
                                      </label>

                                  <div>
                                  <div className="d-flex gap-1">
                                                    <Button
                                                        color="primary"
                                                        className="addUserButton"
                                                        tag={Link}
                                                        to="/create-user"
                                                        id="create-btn"
                                                        
                                                    >
                                                        <i className="ri-add-line align-bottom me-1"></i>
                                                       {t('createUser')}
                                                    </Button>
                                                  
                                      </div>
                                    <BasicTable
                                      searchTerm={searchTerm}
                                      initialData={users}
                                      source='group'
                                    />
                                  </div>
                                </Col>
                              </Row>
                            </CardBody>
                          </Card>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
                <Col lg={12} className="fixed-bottom-buttons">
                  <div className="float-end">
                    <button type="submit" className="ms-1 btn btn-success me-3">
                      {t("save")}
                    </button>
                    <button
                      type="reset"
                      className="btn btn-info"
                      onClick={() => goBack()}
                    >
                      {t("cancel")}
                    </button>
                  </div>
                </Col>
              </Row>
            </Form>
            {addGroupError && (
              <div
                style={{
                  position: "fixed",
                  bottom: "10px",
                  left: "50%",
                  transform: "translateX(-50%)",
                  padding: "10px 20px",
                  backgroundColor:
                    addGroupError.type === "success" ? "green" : "#ff3d60",
                  color: "white",
                  borderRadius: "5px",
                  zIndex: 1000,
                  minWidth: "25%",
                  textAlign: "center",
                  transition: "opacity 0.5s ease-in-out",
                }}
              >
                {addGroupError.text}
              </div>
            )}
          </div>

          </Card>
         
        </Container>
      </div>
    </React.Fragment>
  );
};

export default UpdateGroup;
